import {
  Box,
  TextField,
  Typography,
  ToggleButtonGroup,
  ToggleButton
} from '@mui/material';
import { ActionAutocomplete } from './ActionAutocomplete';
import type { MeasureStep } from '../../types/steps';

type Props = {
  step: MeasureStep;
  onChange: (updates: Partial<MeasureStep>) => void;
};

export const RecordMeasurementForm = ({ step, onChange }: Props) => {
  const useRawTopic = !step.action;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
      <ActionAutocomplete
        value={step.action ?? ''}
        onChange={action => onChange({ action })}
      />
      <TextField
        label="Description"
        size="small"
        fullWidth
        multiline
        minRows={2}
        value={step.description ?? ''}
        onChange={e => onChange({ description: e.target.value })}
        placeholder="Plain-English description of what this measurement records"
      />
      {useRawTopic && (
        <>
          <Typography variant="caption" color="text.secondary">
            Raw MQTT override (advanced)
          </Typography>
          <TextField
            label="Topic"
            size="small"
            fullWidth
            value={step.topic ?? ''}
            onChange={e => onChange({ topic: e.target.value })}
            placeholder="voltbot/station/device/measure"
          />
          <TextField
            label="Payload"
            size="small"
            fullWidth
            multiline
            minRows={2}
            value={step.payload ?? ''}
            onChange={e => onChange({ payload: e.target.value })}
            InputProps={{
              sx: { fontFamily: 'monospace', fontSize: '0.85rem' }
            }}
          />
        </>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Target Field:
        </Typography>
        <ToggleButtonGroup
          size="small"
          exclusive
          value={step.targetField}
          onChange={(_e, val) => {
            if (val !== null)
              onChange({ targetField: val as 'asFound' | 'asLeft' });
          }}
        >
          <ToggleButton value="asFound">As Found</ToggleButton>
          <ToggleButton value="asLeft">As Left</ToggleButton>
        </ToggleButtonGroup>
      </Box>
      <TextField
        label="Timeout (ms)"
        size="small"
        type="number"
        value={step.timeoutMs ?? ''}
        onChange={e => onChange({ timeoutMs: Number(e.target.value) })}
        sx={{ maxWidth: 200 }}
      />
    </Box>
  );
};
